(function () {
  'use strict';

  var toastTimer = null;
  var lastShownAt = 0;
  var fetchPatched = false;

  function cartUrl() {
    return window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
  }

  function getToast() {
    var toast = document.getElementById('screwman-cart-toast');
    if (toast) return toast;

    toast = document.createElement('a');
    toast.id = 'screwman-cart-toast';
    toast.className = 'screwman-cart-toast';
    toast.href = cartUrl();
    toast.setAttribute('aria-label', 'Added to cart. View cart.');
    toast.innerHTML = [
      '<span class="screwman-cart-toast__check" aria-hidden="true">&#10003;</span>',
      '<span class="screwman-cart-toast__copy" aria-live="polite">',
      '<span class="screwman-cart-toast__title">Added to cart</span>',
      '<span class="screwman-cart-toast__link">View cart</span>',
      '</span>',
      '<span class="screwman-cart-toast__arrow" aria-hidden="true">&#8250;</span>'
    ].join('');
    document.body.appendChild(toast);
    return toast;
  }

  function positionToast(toast) {
    var icon = document.querySelector('#cart-icon-bubble, a.header__icon--cart');
    var padding = window.innerWidth < 750 ? 10 : 16;
    var top = 82;
    var right = padding;

    if (icon) {
      var rect = icon.getBoundingClientRect();
      top = Math.max(padding, Math.round(rect.bottom + 8));
      right = Math.max(padding, Math.round(window.innerWidth - rect.right));
    }

    toast.style.top = top + 'px';
    toast.style.right = right + 'px';
  }

  function hideToast() {
    var toast = document.getElementById('screwman-cart-toast');
    if (toast) toast.classList.remove('is-visible');
  }

  function scheduleHide(delay) {
    if (toastTimer) window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(hideToast, delay || 4500);
  }

  function showToast() {
    var toast = getToast();
    var now = Date.now();
    toast.href = cartUrl();
    positionToast(toast);

    if (toastTimer) window.clearTimeout(toastTimer);

    /* Successful add handlers can emit both a fetch result and a custom event. */
    if (now - lastShownAt < 350 && toast.classList.contains('is-visible')) {
      scheduleHide(4500);
      return;
    }

    lastShownAt = now;
    toast.classList.remove('is-visible');
    window.requestAnimationFrame(function () {
      positionToast(toast);
      toast.classList.add('is-visible');
      scheduleHide(4500);
    });
  }

  function requestUrl(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function isCartAddRequest(input) {
    var value = requestUrl(input);
    if (!value) return false;
    try {
      var url = new URL(value, window.location.origin);
      return /\/cart\/add(?:\.js)?\/?$/i.test(url.pathname);
    } catch (error) {
      return /\/cart\/add(?:\.js)?(?:\?|$)/i.test(value);
    }
  }

  function patchFetch() {
    if (fetchPatched || typeof window.fetch !== 'function') return;
    fetchPatched = true;

    var originalFetch = window.fetch;
    window.fetch = function () {
      var args = Array.prototype.slice.call(arguments);
      var cartAdd = isCartAddRequest(args[0]);
      return originalFetch.apply(this, args).then(function (response) {
        if (cartAdd && response && response.ok) {
          window.setTimeout(showToast, 0);
        }
        return response;
      });
    };
  }

  document.addEventListener('screwman:cart-added', showToast);
  document.addEventListener('DOMContentLoaded', function () {
    patchFetch();
    getToast();
  });

  window.addEventListener('resize', function () {
    var toast = document.getElementById('screwman-cart-toast');
    if (toast && toast.classList.contains('is-visible')) positionToast(toast);
  }, { passive: true });

  window.addEventListener('scroll', function () {
    var toast = document.getElementById('screwman-cart-toast');
    if (toast && toast.classList.contains('is-visible')) positionToast(toast);
  }, { passive: true });

  patchFetch();
  if (document.readyState !== 'loading') getToast();
})();
